

interface Props {
    pageCount: number | null;
    page: number;
    setPage: (page: number) => void;
    onFitToHeight: () => void;
}

export function ButtonBar({
    pageCount,
    page,
    setPage,
    onFitToHeight,
}: Props) {
    return (
        <div style={{ position: 'absolute', top: '10px', left: '10px', zIndex: 10 }}>
            <button className='fit-to-height' onClick={(e) => { e.stopPropagation(); onFitToHeight(); }}>
                <img src='/vertical-icon.svg' alt='Fit to height' />
            </button>

            {pageCount && Array.from({ length: pageCount }, (_, idx) =>
                <button
                    style={idx + 1 === page
                        ? { textDecoration: 'underline', }
                        : {}
                    }
                    key={idx}
                    onClick={() => setPage(idx + 1)}>
                    {`Page ${idx + 1}`}
                </button>
            )}
        </div>
    );
}
